export const TRANSLATION_SCOPE = 'errorModule';
export const TRANSLATION_ERROR_SCOPE = [TRANSLATION_SCOPE, 'error'];
